export default "__VITE_ASSET__emOsfGWd__"